<div class="dropdown-container" #dropdownRef>
  <!-- <label>{{ label }}</label> -->
  <div class="dropdown" (click)="toggleDropdown()">
    <input type="text" [placeholder]="placeholder" [(ngModel)]="searchTerm"
      (keydown.enter)="onEnter(); $event.preventDefault()" (input)="filterItems()" (blur)="filterItems()"
 />
    <i *ngIf="showSearchIcon" class="fa fa-search" aria-hidden="true" style="color:#ccc;"></i>
    <i *ngIf="!showSearchIcon" class="fa fa-chevron-down" aria-hidden="true" style="color:#7C7F88;
;"></i>
  </div>

  <ul *ngIf="showDropdown" class="dropdown-list" (scroll)="onScroll($event)">
    <li *ngFor="let item of filteredItems" (click)="selectItem(item)">
      {{ item.key }}
    </li>
    <li *ngIf="filteredItems.length === 0" class="no-results">No hay resultados</li>
  </ul>
</div>